import { Paragraph, Table, TableOfContents } from 'docx';
import { getEmptyLine } from 'src/helpers/print/docxFunctions';
import { MonetaryErosion } from 'src/types/monetaryErosion.type';
import { PrejudiceFormPerteGainsProfessionnelsActuelSaisieDirecte } from 'src/types/prejudice.type';
import { Victime } from 'src/types/victime.type';
import { indemnitesJournalieresPercuesPendantLaPeriodeDArretWrittenPrint } from '../../revenus/steps/indemnitesJournalieresPercuesPendantLaPeriodeDArret.written.print';
import { perteDeGainsProfessionnelsWrittenPrint } from '../../revenus/steps/perteDeGainsProfessionnels.written.print';
import { revenuEspereWrittenPrint } from './revenuEspere.written.print';

export const saisieDirecteStepsWrittenPrint = ({
  formData,
  victime,
  dateLiquidation,
  monetaryErosions,
  isPGPF,
}: {
  formData: PrejudiceFormPerteGainsProfessionnelsActuelSaisieDirecte;
  victime: Victime;
  dateLiquidation: Date | undefined;
  monetaryErosions: MonetaryErosion[];
  isPGPF: boolean;
}): (Table | TableOfContents | Paragraph)[] => {
  return [
    ...(formData.revenuEspere.total
      ? [
          ...revenuEspereWrittenPrint({
            formData,
            victime,
            isPGPF,
          }),
          getEmptyLine(),
        ]
      : []),
    ...(formData.perteDeGainsProfessionnels.total
      ? [
          ...perteDeGainsProfessionnelsWrittenPrint({
            formData,
            perteDeGainsProfessionnels: formData.perteDeGainsProfessionnels,
            dateLiquidation: dateLiquidation,
            monetaryErosions: monetaryErosions,
            revalorisationCoefficientsType:
              formData.revalorisationCoefficientsType,
            victime,
            isPGPF,
          }),
          getEmptyLine(),
        ]
      : []),
    ...(formData.indemnitesJournalieresPercuesPendantLaPeriodeDArret
      .indemnitesJournalieresPercuesNet ||
    formData.indemnitesJournalieresPercuesPendantLaPeriodeDArret.csgRdsTotal
      ? indemnitesJournalieresPercuesPendantLaPeriodeDArretWrittenPrint({
          formData,
          indemnitesJournalieresPercuesPendantLaPeriodeDArret:
            formData.indemnitesJournalieresPercuesPendantLaPeriodeDArret,
          victime,
          isPGPF,
        })
      : []),
  ];
};
